import React from 'react';
import Highlights from './Highlights/Highlights';
import LearningPotential from './LearningPotential/LearningPotential';
import Activities from './Activities/Activities';
import { Box } from '@chakra-ui/react';
import Results from './Results/Results';
import Testimonial from './Testimonial/Testimonial';
import CoBrandedFooterBanner from './CoBrandedFooterBanner/CoBrandedBanner';
import CoBrandedHeaderBanner from './CoBrandedHeaderBanner/CoBrandedHeaderBanner';
import CoBrandedFaq from './CoBrandedFaq/CoBrandedFaq';
import HiringPartners from '../common/HiringPartners/HiringPartners';
import LandingPageAboutUs from './LandingPageAboutUs/LandingPageAboutUs';
import OrgBanner from './OrgBanner/OrgBanner';
import PrepleafRegister from './PrepleafRegister/PrepleafRegister';
import GatewayToDreamCareer from './Gateway/GatewayToDreamCareer';
import { useDomainUIConfig } from '../../hooks/useDomainConfig';
import UnlockingOpportunities from './UnlockingOpportunities/UnlockingOpportunities';
import KnowYourLevelLanding from './KnowYourLevelLanding/KnowYourLevelLanding';
import PrepleafElite from './PrepleafElite/PrepleafElite';

const OrgLandingPage = () => {
	const data = useDomainUIConfig().data;
	return (
		<Box>
			<Box bg="#F7F7FF" style={{ display: 'flex', flexDirection: 'column', gap: '50px' }}>
				{/* {data && data?.headerBanner && (
					<Box mb="100px" order={data?.headerBanner?.order}>
						<CoBrandedHeaderBanner headerBannerData={data?.headerBanner} />
					</Box>
				)} */}

				{data && data?.UnlockingOpportunities && (
					<Box order={data?.UnlockingOpportunities?.order}>
						<UnlockingOpportunities data={data?.UnlockingOpportunities} />
					</Box>
				)}

				{data && data?.knowYourLevel && (
					<Box order={data?.knowYourLevel?.order}>
						<KnowYourLevelLanding data={data?.knowYourLevel} />
					</Box>
				)}

				{data && data?.prepleafElite && (
					<Box order={data?.prepleafElite?.order}>
						<PrepleafElite data={data?.prepleafElite} />
					</Box>
				)}

				{/* {data && data?.orgBanner && (
					<Box order={data?.orgBanner?.order}>
						<OrgBanner data={data?.orgBanner} />
					</Box>
				)} */}
				{/* {data && data?.prepleafRegister && (
					<Box order={data?.prepleafRegister?.order}>
						<PrepleafRegister data={data?.prepleafRegister} />
					</Box>
				)} */}

				{data && data?.prepleafRegister && (
					<Box order={data?.prepleafRegister?.order}>
						<GatewayToDreamCareer data={data?.gatewayToDreamCareer} />
					</Box>
				)}
				{/* 
				{data && data?.aboutUs && (
					<Box mb="100px" order={data?.aboutUs?.order} maxW="1440px" px={{ base: '16px', xl: '80px' }} mx="auto">
						<LandingPageAboutUs aboutUsData={data?.aboutUs} />
					</Box>
				)} */}

				{/* {data && data?.learningPotential && (
					<Box mb="100px" order={data?.learningPotential?.order} maxW="1440px" w="full" px={{ base: '0px', xl: '64px' }} mx="auto">
						<LearningPotential tabsData={data?.learningPotential} />
					</Box>
				)} */}

				{/* {data && data?.highlights && (
					<Box mb="100px" order={data?.highlights?.order} maxW="1440px" px={{ base: '16px', xl: '80px' }} mx="auto">
						<Highlights highlightsData={data?.highlights} />
					</Box>
				)} */}

				{/* {data && data?.activities && (
					<Box order={data?.activities?.order} maxW="1440px" px={{ base: '16px', xl: '80px' }} mx="auto">
						<Activities activitiesData={data?.activities} />
					</Box>
				)} */}

				{data && data?.results && (
					<Box order={data?.results?.order} bg="#5968D8">
						<Results resultsData={data?.results} />
					</Box>
				)}

				{data && data?.testimonial && (
					<Box order={data?.testimonial?.order} maxW="1440px" px={{ base: '16px', xl: '200px' }} mx="auto">
						<Testimonial testimonialData={data?.testimonial} />
					</Box>
				)}

				{data && data?.companiesMarqueeData && (
					<Box order={data?.companiesMarqueeData?.order} mx="auto" w="full">
						<HiringPartners title={data?.companiesMarqueeData?.title} data={data?.companiesMarqueeData?.companiesLogo} />
					</Box>
				)}
				{data && data?.learningPotential && (
					<Box order={data?.learningPotential?.order} maxW="1440px" w="full" px={{ base: '0px', xl: '64px' }} mx="auto">
						<LearningPotential tabsData={data?.learningPotential} />
					</Box>
				)}

				{data && data?.faq && (
					<Box order={data?.faq?.order}>
						<CoBrandedFaq faqData={data?.faq} />
					</Box>
				)}

				{data && data?.footerBanner && (
					<Box order={data?.footerBanner?.order}>
						<CoBrandedFooterBanner footerBannerData={data?.footerBanner} />
					</Box>
				)}
			</Box>
		</Box>
	);
};

export default OrgLandingPage;
